import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Call, CallAndPhoto } from '../state-man/models/call.model';
import { LoggerService } from './logger.service';
import { UiService } from './ui.service';
import { PhotoService } from './photo.service';
import { Photo } from '../state-man/models/photo.model';

@Injectable({
  providedIn: 'root'
})
export class CallService {

  constructor(
    private apiService: ApiService,
    private uiService: UiService
  ) { }

  public async getMine () : Promise<Call[] | null> {
    try {      
      const ret = await this.apiService.apiReturnsAny('get', 'call/mine/')
      const calls = (ret && Array.isArray(ret)) ? Call.buildMany(ret) : null

      if (!calls) return null
      return calls
    } catch (error) {
      LoggerService.log(error + 'call/mine')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }    
  }  


  public async addCall(call_entry: Call) : Promise<Call | null> {
    try {
      const body = call_entry
      const obj = await this.apiService.apiReturnsAny('post', 'call/', body, 'application/json')
      return obj
    } catch (error) {
      LoggerService.log(error + 'post call/')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }    
  }   

  public async updateCall(call_entry: Call) : Promise<Call | null> {
    try {          
      const body = call_entry
      const obj = await this.apiService.apiReturnsAny('put', 'call/' + call_entry.id, body, 'application/json')
      return obj      
    } catch (error) {
      LoggerService.log(error + 'put call/')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }    
  }

  public async deleteCall(call_entry: Call) : Promise<any> {
    try {
      const ret = await this.apiService.apiReturnsAny('delete', 'call/' + call_entry.id)
      return ret
    } catch (error) {
      LoggerService.log(error + 'delete call/')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')  
      return null
    }    
  }

  public async addPhoto (call: Call, photo: Photo) : Promise<Photo | null> {
    try {
      const body = new FormData()
      const base64Image = photo.base64_sz.split(';base64,').pop()
      const blob = PhotoService.b64toBlob(base64Image, photo.file_type)
      body.append('media_file', blob, 'media_file')
      return await this.apiService.apiReturnsAny('post', '/call/photo/' + call.id, body, 'multipart/form-data')
    } catch (error) {
      LoggerService.log(error + '/jsa/media/')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')
      return null
    }
  }

  public async deletePhoto (call: CallAndPhoto) : Promise<any> {
    try {
      return await this.apiService.apiReturnsAny('delete', '/call/photo/' + call.photo.id)
    } catch (error) {
      LoggerService.log(error + '/jsa/media/')
      await this.uiService.showToast('An unexpected error occurred and has been sent to the support team.')
      return null
    }
  }

  public async getPhotosByCall (call: Call) : Promise<any> {
    try {
      const ret = await this.apiService.apiReturnsAny('get', '/call/photos/' + call.id)
      return (ret && Array.isArray(ret)) ? Photo.buildMany(ret) : []
    } catch (error) {
      LoggerService.log(error + '/jsa/media/');
    }
  }
}
